import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { HttpHeaders } from '@angular/common/http';
import { PaginationDto, ResponsePackage } from 'shared-lib';
import { UtilityList } from 'shared-lib';
@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private config: AppConfig) {
    this.pathApi = this.config.setting['pathApi'] + 'utility/';
  }

  getUtilitiesForSelect(): Observable<any> {
    return this.http.get(`${this.pathApi}getUtilitiesForSelect`);
  }
  add(obj: any, image: File | null) {
    let formData: FormData = new FormData();
    if (image != null) formData.append('image', image, image.name);
    formData.append('id', obj.id ?? 0);
    formData.append('name', obj.name);
    formData.append('acronym', obj.acronym);
    if (obj.utilityIdCopyFrom)
      formData.append('utilityIdCopyFrom', obj.utilityIdCopyFrom);
    formData.append('fullName', obj.fullName);
    formData.append('currency', obj.currency);
    formData.append('country', obj.country);
    formData.append('language', obj.language);
    formData.append('subdomain', obj.subdomain);
    formData.append('colorCode', obj.colorCode);
    formData.append('translations', JSON.stringify(obj.translations));
    formData.append('imageUrl', obj.imageUrl ?? '');
    formData.append(
      'kycDataInString',
      JSON.stringify(obj.kycConsentConfiguration)
    );
    obj.dashboardConfiguration.forEach((config: string) =>
      formData.append('dashboardConfiguration', config)
    );
    formData.append('contactPersonString', JSON.stringify(obj.contactPerson));
    formData.append('BankDetailsDataInString', JSON.stringify(obj.bankDetails));
    formData.append(
      'CodePatternsDataInString',
      JSON.stringify(obj.codePatterns)
    );
    formData.append('ValidationRulesDataInString', JSON.stringify(obj.validationRules));
    formData.append('MapConfiguration', JSON.stringify(obj.mapConfiguration));
    formData.append('aiMapConfiguration', JSON.stringify(obj.aiMapConfiguration));
    formData.append('ConfigurationGenerationDataInString', JSON.stringify(obj.configurationGenerations))
    formData.append('DefaultCaimsCodePatterns', obj.defaultCaimsCodePatterns);
    formData.append('ActiveDirectoryDataInString', JSON.stringify(obj.activeDirectoryConfiguration));
    formData.append('isSelectedAreasForMobileLimited', JSON.stringify(obj.isSelectedAreasForMobileLimited))
    if (obj.maximumSelectedAreasForMobile)
      formData.append('maximumSelectedAreasForMobile', obj.maximumSelectedAreasForMobile)

    formData.append('SendgridApiKey', obj.sendgridApiKey ?? '');
    formData.append('SenderEmail', obj.senderEmail ?? '');

    return this.http.post<ResponsePackage<string>>(
      `${this.pathApi}add`,
      formData
    );
  }

  addNewSubdomain(obj: any): Observable<any> {
    return this.http.post<ResponsePackage<string>>(
      `${this.pathApi}addNewSubdomain`,
      obj
    );
  }

  retryDatabaseCreation(obj: any): Observable<any> {
    return this.http.post<ResponsePackage<string>>(
      `${this.pathApi}retryDatabaseCreation`,
      obj
    );
  }

  getall(obj: any) {
    return this.http.post<ResponsePackage<PaginationDto<UtilityList>>>(
      `${this.pathApi}getAll`,
      obj
    );
  }

  get(id?: number) {
    return this.http.get<ResponsePackage<any>>(
      `${this.pathApi}get/${id ?? -1}`,
      { headers: this.headers, observe: 'response' }
    );
  }

  getByName(name: string) {
    return this.http.get<ResponsePackage<any>>(
      `${this.pathApi}getByName/${name}`,
      { headers: this.headers, observe: 'response' }
    );
  }
  setStatus(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}setStatus`, obj);
  }
}
